// Shared constants for the ideas feature

export const IDEA_MODES = [
    {
        value: 'smart',
        label: 'Smart Ideas',
        icon: 'AutoAwesome',
        description: 'Personalized to your niche and voice',
        proOnly: false,
    },
    {
        value: 'fill_gap',
        label: 'Fill the Gap',
        icon: 'Explore',
        description: 'Topics and formats you haven\'t covered',
        proOnly: true,
    },
    {
        value: 'double_down',
        label: 'Double Down',
        icon: 'Whatshot',
        description: 'Replicate your top-performing patterns',
        proOnly: true,
    },
    {
        value: 'trending_you',
        label: 'Trending + You',
        icon: 'TrendingUp',
        description: 'Today\'s trends through your lens',
        proOnly: true,
    },
];

export const SCORE_COLORS = {
    high: '#10b981',    // 70-100
    medium: '#f59e0b',  // 40-69
    low: '#9ca3af',     // 0-39
};

export function getScoreColor(score) {
    if (score == null) return SCORE_COLORS.low;
    if (score >= 70) return SCORE_COLORS.high;
    if (score >= 40) return SCORE_COLORS.medium;
    return SCORE_COLORS.low;
}

export const PLATFORMS = [
    { value: null, label: 'All Platforms', icon: '🌐' },
    { value: 'Instagram', label: 'Instagram', icon: '📸' },
    { value: 'LinkedIn', label: 'LinkedIn', icon: '💼' },
    { value: 'Twitter', label: 'Twitter / X', icon: '🐦' },
    { value: 'YouTube', label: 'YouTube', icon: '▶️' },
    { value: 'TikTok', label: 'TikTok', icon: '🎵' },
    { value: 'Facebook', label: 'Facebook', icon: '👥' },
];

export const FORMAT_COLORS = {
    'Short Post': '#6366f1',
    'Thread': '#8b5cf6',
    'Story': '#ec4899',
    'Reel/Video': '#ef4444',
    'Carousel': '#f59e0b',
    'Poll': '#10b981',
};

export const ENGAGEMENT_COLORS = {
    High: '#10b981',
    Medium: '#f59e0b',
    Low: '#9ca3af',
};

export const EXAMPLE_TOPICS = [
    'healthy recipes',
    'tech gadgets',
    'travel tips',
    'fitness motivation',
    'business strategies',
    'lifestyle hacks',
    'personal finance',
    'mental health',
    'photography tips',
    'remote work',
];

export const PLATFORM_COLORS = {
    Instagram: '#e1306c',
    LinkedIn: '#0077b5',
    Twitter: '#1da1f2',
    YouTube: '#ff0000',
    TikTok: '#010101',
    Facebook: '#1877f2',
    Pinterest: '#e60023',
    Reddit: '#ff4500',
};
